import visitFormService from "@/services/api/visitForm";
import { handleResponse } from "@/services/axios";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import {
  createAsyncThunk,
  createSlice,
  isPending,
  isFulfilled,
  isRejected,
} from "@reduxjs/toolkit";
interface Loading {
  crmForm: boolean;
  DynamicForm: boolean;
  formAnswer: boolean;  
}

interface visitFormState {
  crmForms: any[];
  formStat: any | null;
  isFetching: boolean;
  error: string | null;
  answerForm: any | null;
  dynamicForm: any[];
  intercom: any[];
  dynamicFormById: any[];
  companyMember: any[];
  totalRecord: number | null;
  isVisitFormLoading: boolean;
  formAnswer: any[]; 
  loading: Loading;
}

const initialState: visitFormState = {
  crmForms: [],
  formStat: [],
  isFetching: false,
  error: null,
  answerForm: [],
  dynamicForm: [],
  intercom: [],
  dynamicFormById: [],
  companyMember: [],
  totalRecord: 0,
  isVisitFormLoading: false,
  formAnswer: [], 
  loading: {
    crmForm: false,
    DynamicForm: false,
    formAnswer: false,  
  },
};

export const getCRMForms = createAsyncThunk(
  "visitForm/getCRMForms",
  async (__, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getCrmForm();
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get Forms");
    }
  },
);

export const getFormStats = createAsyncThunk(
  "visitForm/getFormStats",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getFormStats(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get FormStats");
    }
  },
);

export const emailFormAnswerReport = createAsyncThunk(
  "visitForm/emailFormAnswerReport",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.emailFormAnswerReport(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to send Email");
    }
  },
);

export const deleteForm = createAsyncThunk(
  "visitForm/deleteForm",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.deleteForm(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to delete form");
    }
  },
);

export const getVisitForm = createAsyncThunk(
  "visitForm/getVisitForm",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getVisitForm(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get visitForm");
    }
  },
);

export const createForm = createAsyncThunk(
  "visitForm/createForm",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.createForm(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to add form");
    }
  },
);

export const getDynamicForm = createAsyncThunk(
  "visitForm/getDynamicForm",
  async (__, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getDynamicForm();
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get Forms");
    }
  },
);

export const getIntercomWithOwner = createAsyncThunk(
  "visitForm/getIntercomWithOwner",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getIntercomWithOwner(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get Intercom");
    }
  },
);
export const getDyanmicFromById = createAsyncThunk(
  "visitForm/getDyanmicFromById",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getDyanmicFromById(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get form");
    }
  },
);

export const createDynamicForm = createAsyncThunk(
  "visitForm/createForm",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.createDynamicForm(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to add form");
    }
  },
);

export const getCompanyMembers = createAsyncThunk(
  "visitForm/getCompanyMembers",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.getCompanyMembers(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get members");
    }
  },
);

export const getFormAnswer = createAsyncThunk(
  "visitForm/getFormAnswer",
  async (params: any, { rejectWithValue }) => { 
    try {
      const response = await visitFormService.formAnswer(params); 
      return handleResponse(response, rejectWithValue); 
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to get answer");
    }   
  }
);

export const submitAnswer = createAsyncThunk(
  "visitForm/submitAnswer",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.submitAnswer(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to submit");
    }
  },
);

export const exportExcel = createAsyncThunk(
  "visitForm/exportExcel",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await visitFormService.exportExcel(params);
      return saveAsExcelFile(response, "FormReport");
    } catch (err: any) {
      return rejectWithValue(err?.Message || "Failed to export");
    }
  },
);

const vistFormSlice = createSlice({
  name: "visitForm",
  initialState,
  reducers: {
    clearVisitForm: (state) => {
      state.crmForms = [];
    },
    clearFormStats: (state) => {
      state.formStat = null;
    },
    clearDynamicFormById: (state) => {
      state.dynamicFormById = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCRMForms.pending, (state) => {
      state.loading.crmForm = true;
    });
    builder.addCase(getCRMForms.fulfilled, (state, action) => {
      state.crmForms = action.payload;
      state.loading.crmForm = false;
    });
    builder.addCase(getCRMForms.rejected, (state) => {
      state.loading.crmForm = false;
    });
    builder.addCase(getFormStats.fulfilled, (state, action) => {
      state.formStat = action.payload;
    });

    builder.addCase(getVisitForm.pending, (state) => {
      state.isVisitFormLoading = true;
      state.answerForm = null;
    });

    builder.addCase(getVisitForm.fulfilled, (state, action) => {
      state.isVisitFormLoading = false;
      state.answerForm = action.payload;
    });

    builder.addCase(getVisitForm.rejected, (state) => {
      state.isVisitFormLoading = false;
    });
    builder.addCase(getDynamicForm.pending, (state) => {
      state.loading.DynamicForm = true;
    });
    builder.addCase(getDynamicForm.fulfilled, (state, action) => {
      state.dynamicForm = action.payload;
      state.loading.DynamicForm = false;
    });
    builder.addCase(getDynamicForm.rejected, (state) => {
      state.loading.DynamicForm = false;
    });
    builder.addCase(getIntercomWithOwner.fulfilled, (state, action) => {
      state.intercom = action.payload;
    });
    builder.addCase(getDyanmicFromById.fulfilled, (state, action) => {
      state.dynamicFormById = action.payload;
    });
    builder.addCase(getCompanyMembers.fulfilled, (state, action) => {
      state.companyMember = action.payload?.Members;
      state.totalRecord = action.payload?.TotalRecords;
    });
    builder.addCase(getFormAnswer.pending, (state) => {
      state.loading.formAnswer = true;
    });
    builder.addCase(getFormAnswer.fulfilled, (state, action) => {
      state.formAnswer = action.payload;
      state.loading.formAnswer = false;
    });
    builder.addCase(getFormAnswer.rejected, (state) => {
      state.loading.formAnswer = false;
    });

    builder
      .addMatcher(isPending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addMatcher(isFulfilled, (state) => {
        state.isFetching = false;
      })
      .addMatcher(isRejected, (state, action: any) => {
        state.isFetching = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});
export const { clearVisitForm, clearFormStats, clearDynamicFormById } =
  vistFormSlice.actions;
export default vistFormSlice.reducer;
